import { useRouter } from 'next/router';
import querystring from 'querystring';
import { omitFromObject } from 'utils/object';

export default function useQuery(propertiesToOmit) {
  const router = useRouter();
  const queryStringIndex = router.asPath?.indexOf('?');
  if (queryStringIndex === -1) {
    return {
      asObject: {},
      asString: ''
    };
  }

  let query = querystring.parse(
    router.asPath.substr(router.asPath?.indexOf('?') + 1)
  );

  if (Object.keys(query).length > 0) {
    query = omitFromObject(query, propertiesToOmit);
  }

  return {
    asObject: query,
    asString:
      Object.keys(query).length > 0 ? `${querystring.stringify(query)}` : ''
  };
}
